import {
  Autocomplete,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomPagination from "../CustomPagination";
import { GET_CUSTOMER_BROKER_TABLE } from "../../../constants/ApiRoute";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import moment from "moment";
import sortupdownarrowIcon from "../../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../../images/sort_down_arrow.svg";
import NoRecordFound from "../../comman/NoRecordFound";

export default function BrokerTable(props) {
  const {
    customerTab,
    setCustomerTab,
    valueTopTap,
    selectedBroker,
    brokerDropDownList,
    setSelectedBroker,
    brokerTab,
  } = props;
  const [sortedData, setSorteddata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [sortClickedTime, setSortClickedTime] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  console.log(sortedData, "newwwwwwwwwwwwwwwwwwwww");

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const formatNumber = (number) => {
    return number.toString().padStart(2, "0");
  };

  const sortData = (data, key, direction) => {
    return data.sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  const getCustomerBrokerDetails = async (custId) => {
    setLoading(true);
    let data = {
      customerId: customerTab?.customerId ? customerTab?.customerId : custId,
      sort: order,
      orderBy: orderBy,
    };
    const config = {
      method: "GET",
      url: GET_CUSTOMER_BROKER_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setSorteddata(data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset page to 1 when search query changes
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    setSortClickedTime(new Date().toLocaleString());

    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const fieldsToSearch = [
    "Name",
    "TotalHours",
    "DayRate",
    "TotalBilling",
    "LastActive",
  ];

  // Filter the entire dataset
  const filteredData = sortedData.filter((item) =>
    fieldsToSearch.some((field) => {
      let fieldValue = item[field];

      // Special handling for `LastActive`
      if (field === "LastActive") {
        fieldValue = item.LastActive
          ? moment.utc(item.LastActive).format("MMM DD YYYY h:mmA")
          : "";
      }

      return (
        fieldValue &&
        String(fieldValue)
          .toLocaleLowerCase()
          .includes(searchQuery.toLocaleLowerCase())
      );
    })
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  console.log(totalPages, "totalPagestotalPagestotalPages", rowsPerPage);
  console.log(paginatedData, "paginatedDatapaginatedData", page);

  useEffect(() => {
    getCustomerBrokerDetails(customerTab.custId);
  }, [customerTab.custId, order, orderBy]);

  const handleProjectNavigate = (val, projID) => {
    console.log(val, "valvalvalvalvalval");
    const selectedBroker = brokerDropDownList.find(
      (item) => item.BrokerID == val
    );
    if (valueTopTap == "11") {
      setCustomerTab((prevState) => ({
        ...prevState,
        brokerId: selectedBroker?.BrokerID
      }));
    } else {
      setSelectedBroker(selectedBroker);
      setCustomerTab((prevState) => ({
        ...prevState,
        customerId: "",
        projectId: "",
        brokerId: selectedBroker?.BrokerID
      }));
    }
  };

  // console.log(aggregatedArray, 'aggregatedArrayaggregatedArrayaggregatedArray')

  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Name"}
                  direction={orderBy === "Name" ? order : "asc"}
                  onClick={() => handleSort("Name")}
                  IconComponent={() => getSortIcon("Name")}
                  style={orderBy === "Name" ? { color: "#007fff" } : {}}
                >
                  Name
                </TableSortLabel>
              </TableCell>
              <TableCell sx={{ minWidth: "185px" }}>
                <TableSortLabel
                  active={orderBy === "LastActive"}
                  direction={orderBy === "LastActive" ? order : "asc"}
                  onClick={() => handleSort("LastActive")}
                  IconComponent={() => getSortIcon("LastActive")}
                  style={orderBy === "LastActive" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "LastActive"}
                  // direction={
                  //   sortConfig.key === "LastActive"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("LastActive")}
                >
                  Last Activity
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "TotalHours"}
                  direction={orderBy === "TotalHours" ? order : "asc"}
                  onClick={() => handleSort("TotalHours")}
                  IconComponent={() => getSortIcon("TotalHours")}
                  style={orderBy === "TotalHours" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "TotalHours"}
                  // direction={
                  //   sortConfig.key === "TotalHours"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("TotalHours")}
                >
                  Total Hours
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "DayRate"}
                  direction={orderBy === "DayRate" ? order : "asc"}
                  onClick={() => handleSort("DayRate")}
                  IconComponent={() => getSortIcon("DayRate")}
                  style={orderBy === "DayRate" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "DayRate"}
                  // direction={
                  //   sortConfig.key === "DayRate" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("DayRate")}
                >
                  Day Rate
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "TotalBilling"}
                  direction={orderBy === "TotalBilling" ? order : "asc"}
                  onClick={() => handleSort("TotalBilling")}
                  IconComponent={() => getSortIcon("TotalBilling")}
                  style={orderBy === "TotalBilling" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "TotalBilling"}
                  // direction={
                  //   sortConfig.key === "TotalBilling"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("TotalBilling")}
                >
                  Total Billing
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((val, index) => (
                <TableRow key={index}>
                  {console.log("chk", val)}

                  <TableCell
                    sx={
                      val.Name
                        ? {
                            color: "#007FFF !important",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }
                        : {}
                    }
                    onClick={() =>
                      handleProjectNavigate(val.UserID, val.projID)
                    }
                  >
                    {val.Name ? val.Name : "-"}
                  </TableCell>
                  <TableCell>
                    {val.LastActive
                      ? moment.utc(val.LastActive).format("MMM DD YYYY h:mmA")
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {val.TotalHours ? val.TotalHours?.toFixed(2) : "0.00"}
                  </TableCell>
                  <TableCell>
                    $
                    {val.DayRate ? formatNumber(val.DayRate?.toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "700 !important" }}>
                    $
                    {val.TotalBilling
                      ? formatNumber(val.TotalBilling?.toFixed(2))
                      : "0.00"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {paginatedData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            count={totalPages}
            // hidePrevButton
            // hideNextButton
            page={page}
            onChange={handlePageChange}
          />
          //   <Pagination
          //   count={totalPages}
          //   page={page}
          //   onChange={handlePageChange}
          //   sx={{ mt: 2,  }}
          //   color="primary"
          // />
        )}
      </TableContainer>
    </div>
  );
}
